import React from 'react';
import {isArrayLike as isArrayLikeMobx} from "mobx";

export function moveItem(array, old_index, new_index) {
  if (new_index >= array.length) {
    let k = new_index - array.length;
    while ((k--) + 1) {
      array.push(undefined);
    }
  }
  array.splice(new_index, 0, array.splice(old_index, 1)[0]);
}

export function removeItem(array: any[], item: any) : void {
  if (array) {
    let indexOf = array.indexOf(item);
    if (indexOf !== -1) {
      array.splice(indexOf, 1);
    }
  }
}

/**
 *
 * @param array
 * @param separator
 * @returns {*}
 */
export function joinNonNull(array: any[], separator: string) : string {
  if (!array || !array.length) {
    return '';
  } else {
    return array.filter(v => !!v || v === 0).join(separator);
  }
}

export function addSeparator(array, separator) {
  if (array && array.length > 1) {
    let newArray = [array[0]];
    for(let i = 1; i < array.length; i++) {
      newArray.push(React.cloneElement(separator, {key: 'sep' + i}));
      newArray.push(array[i]);
    }
    return newArray;
  } else {
    return array;
  }
}

export function addSeparatorBetweenArrays(separator, ...arrays): any[] {
  let returnArray;

  if (!arrays || arrays.length === 0) {
    returnArray = [];
  } else if (arrays.length === 1) {
    returnArray =  (arrays[0]) ? arrays[0] : [];
  } else {
    let newArray = (arrays[0]) ? arrays[0] : [];
    for(let i = 1; i < arrays.length; i++) {
      let oneArray = arrays[i];
      if (oneArray && oneArray.length) {
        if (newArray.length) newArray.push(React.cloneElement(separator, {key: 'sep' + i}));
        for(let h = 0; h < oneArray.length; h++) {
          newArray.push(oneArray[h]);
        }
      }
    }
    returnArray =  newArray;
  }

  return (returnArray && returnArray.length)? returnArray.filter(x => x) : returnArray;
}


export function areArraysEqual(a, b) {
  if (!a || !b) return false;

  if (a.length != b.length) return false;

  for (let i = 0, length = a.length; i < length; i++) {
    if (a[i] != b[i]) return false;
  }

  return true;
}


export function toArray<T>(a: T|T[]) : T[] {
  if (a == null) {
    return [];
  } else {
    return (isArrayLikeMobx(a)) ? a : [a];
  }
}

export function notEmpty(a: any[]) : boolean {
  return (a && !!a.length);
}



// WEBPACK FOOTER //
// ./src/core/common/utils/arrayUtils.ts